import { Injectable } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export const AUTH_PASS_MIN_LENGTH: number = 8;
export const PROVINCE_CODE_MAX_LENGTH: number = 2;
export const AUTH_PASS_PATTERN: string = '^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,}$';
export const PIVA_PATTERN: string = '^[0-9]{11}$';
export const OTP_PATTERN: string = '^[0-9]{6}$';
export const STRING_PATTERN: string = '^[a-zA-Z0-9 /&_.-]*$';
export const SIMPLE_STRING_PATTERN: string = '^[a-zA-Z0-9]*$';
export const BUYER_NAME_PATTERN: string = "^[a-zA-ZàèéìòùÀÈÉÌÒÙ0-9 /&_.'-]*$";
export const NUMBER_PATTERN: string = '^[0-9,.+-]*$';
export const DOMICILE_ZIP_CODE_PATTERN: string = '^[a-zA-Z0-9 -]*$';
export const WEBSITE_PATTERN: string = '^[a-zA-Z0-9&_.:/-]*$';
export const STRING_SPECIAL_CHAR_PATTERN: string = "^[a-zA-Z0-9àèéìòùÀÈÉÌÒÙ /&_.\\-',]*$";
export const NOTE_PATTERN: string = '^[a-zA-Z0-9 àèéìòùÀÈÉÌÒÙ /&_.\\-€$£"!?\\\\%()=\'^,:;_+*#§°@ç|<>\\[\\]{}]*$';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  email_label: string = 'email';
  password_label: string = 'password';
  password_confirm_label: string = 'password_confirm';
  otp_label: string = 'otp';
  company_id_label: string = 'company_id';
  business_name_label: string = 'business_name';
  vat_label: string = 'vat';
  status_label: string = 'status';
  unsolved_label: string = 'unsolved';
  cms_label: string = 'cms';
  name_label: string = 'name';
  store_id_label: string = 'store_id';
  is_enabled_label: string = 'is_enabled';
  is_partially_enabled_label: string = 'is_partially_enabled';
  is_web_sale_enabled_label: string = 'is_web_sale_enabled';
  is_in_store_sale_enabled_label: string = 'is_in_store_sale_enabled';
  is_store_payment_method_enabled_label: string = 'is_store_payment_method_enabled';
  is_ext_order_id_enabled_label: string = 'is_ext_order_id_enabled';
  is_tax_deduction_enabled_label: string = 'is_tax_deduction_enabled';
  is_tax_date_and_number_enabled_label: string = 'is_tax_date_and_number_enabled';
  is_custom_domains_enabled_label: string = 'is_custom_domains_enabled';
  is_iban_refund_enabled_label: string = 'is_iban_refund_enabled';
  sales_network_id_label: string = 'sales_network_id';
  product_category_label: string = 'product_category';
  sales_network_type_label: string = 'sales_network_type';
  origin_label: string = 'origin';
  tax_deduction_label: string = 'tax_deduction';
  channel_label: string = 'channel';
  created_from_label: string = 'created_from';
  created_to_label: string = 'created_to';
  completed_from_label: string = 'completed_from';
  completed_to_label: string = 'completed_to';
  due_date_from_label: string = 'due_date_from';
  due_date_to_label: string = 'due_date_to';
  last_operation_label: string = 'last_operation';
  last_operation_from_label: string = 'last_operation_from';
  last_operation_to_label: string = 'last_operation_to';
  website_label: string = 'website';
  min_amount_label: string = 'min_amount';
  max_amount_label: string = 'max_amount';
  order_id_label: string = 'order_id';
  step_id_label: string = 'step_id';
  buyer_name_label: string = 'buyer_name';
  buyer_id_label: string = 'buyer_id';
  seller_name_label: string = 'seller_name';
  seller_id_label: string = 'seller_id';
  phone_prefix_label: string = 'phone_prefix';
  phone_value_label: string = 'phone_value';
  from_label: string = 'from';
  to_label: string = 'to';
  firstname_label: string = 'firstname';
  lastname_label: string = 'lastname';
  tax_deduction_type_label: string = 'tax_deduction_type';
  bd1_label: string = 'bd1';
  bd2_label: string = 'bd2';
  bd5_label: string = 'bd5';
  liquidation_label: string = 'liquidation';
  qinetic_id_label: string = 'qinetic_id';
  qinetic_bug_label: string = 'qinetic_bug';
  has_qinetic_id_label: string = 'has_qinetic_id';
  merchant_refund_label: string = 'merchant_refund';
  steps_id_label: string = 'steps_id';
  unpaid_days_label: string = 'unpaid_days';
  store_name_label: string = 'store_name';
  company_name_label: string = 'company_name';
  external_id_label: string = 'external_id';
  approved_label: string = 'approved';
  phone_number_label = 'phone_number';
  is_confirmed_label = 'is_confirmed';
  owner_link = 'owner_link';
  type_label = 'type';
  client_id_label: string = 'client_id';
  client_secret_label: string = 'client_secret';
  is_bnpl_long_enabled_label: string = 'is_bnpl_long_enabled';
  is_sdd_payment_enabled_label: string = 'is_sdd_payment_enabled';
  subdomain_label: string = 'subdomain';
  report_type_label: string = 'report_type';
  agreement_label: string = 'agreement';
  sales_reference_email_label: string = 'sales_reference_email';
  onboarding_completed_from_label: string = 'onboarding_completed_from';
  onboarding_completed_to_label: string = 'onboarding_completed_to';
  last_login_from_label: string = 'last_login_from';
  last_login_to_label: string = 'last_login_to';
  amount_min_label: string = 'amount_min';
  amount_max_label: string = 'amount_max';
  script_type_label: string = 'script_type';
  exclude_gdpr_label: string = 'exclude_gdpr';

  /* Buyer residency/domicile address */
  country_label: string = 'country';
  city_label: string = 'city';
  province_label: string = 'province';
  address_label: string = 'address';
  house_number_label: string = 'house_number';
  zip_code_label: string = 'zip_code';

  /* Buyer personal info */
  buyer_firstname_label: string = 'buyer_firstname';
  buyer_lastname_label: string = 'buyer_lastname';
  tax_code_label: string = 'tax_code';
  birthday_label: string = 'birthday';
  birthplace_label: string = 'birthplace';
  birthregion_label: string = 'birthregion';
  birthcountry_label: string = 'birthcountry';
  birthregion_code_label: string = 'birthregion_code';
  gender_label: string = 'gender';
  citizenship_label: string = 'citizenship';
  secondary_citizenship_label: string = 'secondary_citizenship';
  cdg_label: string = 'cdg';
  communication_channel_label: string = 'communication_channel';

  /* Buyer personal Id  */
  issuer_label: string = 'issuer';
  doc_type_label: string = 'doc_type';
  doc_number_label: string = 'doc_number';
  issuer_type_label: string = 'issuer_type';
  issue_country_label: string = 'issue_country';
  issue_province_label: string = 'issue_province';
  emission_date_label: string = 'emission_date';
  expiration_date_label: string = 'expiration_date';

  /* Buyer AML */
  activity_label: string = 'activity';
  sector_label: string = 'sector';
  occupation_label: string = 'occupation';
  is_apical_subject_label: string = 'is_apical_subject';
  business_place_label: string = 'business_place';
  tae_label: string = 'tae';
  activity_code_label: string = 'activity_code';
  sector_code_label: string = 'sector_code';
  occupation_code_label: string = 'occupation_code';

  note_label: string = 'note';
  stand_by_notes_label: string = 'stand_by_notes';

  is_prepaid_cards_blocked_label: string = 'is_prepaid_cards_blocked';
  is_prepaid_cards_blocked_on_long_label: string = 'is_prepaid_cards_blocked_on_long';
  is_prepaid_cards_blocked_on_ecommerce_label: string = 'is_prepaid_cards_blocked_on_ecommerce';

  is_fourthline_onboarding_enabled_label: string = 'is_fourthline_onboarding_enabled';

  /* Pending invitations */
  recipient_email_label: string = 'recipient_email';
  company_business_name_label: string = 'company_business_name';
  sender_email_label: string = 'sender_email';

  confirm_reason_label: string = 'confirm_reason';

  /* vop_request */
  beneficiary_firstname_label: string = 'beneficiary_firstname';
  beneficiary_lastname_label: string = 'beneficiary_lastname';
  beneficiary_tax_code_label: string = 'beneficiary_tax_code';
  beneficiary_iban_label: string = 'beneficiary_iban';
  vop_request_id_label: string = 'vop_request_id';
  result_label: string = 'result';
  iban_label: string = 'iban';

  /* product_category */
  product_category_name_label: string = 'name';
  product_category_decido_evaluation_code_label: string = 'decido_evaluation_code';
  product_category_first_subcategory_label: string = 'first_subcategory';
  product_category_installment_plans_label: string = 'installment_plans';
  product_subcategory_name_label: string = 'name';
  product_subcategory_ecommerce_default_label: string = 'ecommerce_default';

  auth_signin_form_group: FormGroup = new FormBuilder().group({
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.maxLength(50),
        Validators.pattern(AUTH_PASS_PATTERN),
      ],
    ],
  });

  auth_mfa_form_group: FormGroup = new FormBuilder().group({
    otp_0: ['', [Validators.required]],
    otp_1: ['', [Validators.required]],
    otp_2: ['', [Validators.required]],
    otp_3: ['', [Validators.required]],
    otp_4: ['', [Validators.required]],
    otp_5: ['', [Validators.required]],
  });

  auth_new_password_form_group: FormGroup = new FormBuilder().group({
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.maxLength(50),
        Validators.pattern(AUTH_PASS_PATTERN),
      ],
    ],
    password_confirm: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.maxLength(50),
        Validators.pattern(AUTH_PASS_PATTERN),
      ],
    ],
  });

  auth_pss_reset_form_group: FormGroup = new FormBuilder().group({
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
  });

  auth_pss_reset_confirm_form_group: FormGroup = new FormBuilder().group({
    otp_0: ['', [Validators.required]],
    otp_1: ['', [Validators.required]],
    otp_2: ['', [Validators.required]],
    otp_3: ['', [Validators.required]],
    otp_4: ['', [Validators.required]],
    otp_5: ['', [Validators.required]],
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.pattern(AUTH_PASS_PATTERN),
        Validators.maxLength(50),
      ],
    ],
    password_confirm: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_PASS_MIN_LENGTH),
        Validators.pattern(AUTH_PASS_PATTERN),
        Validators.maxLength(50),
      ],
    ],
  });

  companies_filters_from_group: FormGroup = new FormBuilder().group({
    company_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    business_name: ['', [Validators.maxLength(70), Validators.pattern(BUYER_NAME_PATTERN)]],
    vat: ['', [Validators.maxLength(11)]],
    sales_network_id: [''],
    status: [''],
    product_category: [''],
    agreement: [''],
    origin: [''],
  });

  vop_requests_filters_from_group: FormGroup = new FormBuilder().group({
    vop_request_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    status: [''],
    result: [''],
    beneficiary_firstname: ['', [Validators.maxLength(50), Validators.pattern(BUYER_NAME_PATTERN)]],
    beneficiary_lastname: ['', [Validators.maxLength(50), Validators.pattern(BUYER_NAME_PATTERN)]],
    beneficiary_tax_code: ['', Validators.pattern(STRING_PATTERN)],
    beneficiary_iban: [''],
    order_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    buyer_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
  });

  archived_companies_filters_from_group: FormGroup = new FormBuilder().group({
    company_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    business_name: ['', [Validators.maxLength(70), Validators.pattern(BUYER_NAME_PATTERN)]],
    vat: ['', [Validators.maxLength(11)]],
  });

  stores_filters_from_group: FormGroup = new FormBuilder().group({
    store_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    name: ['', [Validators.maxLength(70), Validators.pattern(BUYER_NAME_PATTERN)]],
    status: [''],
    cms: [''],
    vat: [''],
    business_name: [''],
    sales_network_id: [''],
    company_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
  });

  store_order_requirements_from_group: FormGroup = new FormBuilder().group({
    is_enabled: [''],
    is_partially_enabled: [''],
    is_web_sale_enabled: [''],
    is_in_store_sale_enabled: [''],
  });

  store_order_ticket_requirements_from_group: FormGroup = new FormBuilder().group({
    min_amount: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    max_amount: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    is_bnpl_long_enabled: [''],
  });

  company_order_ticket_requirements_from_group: FormGroup = new FormBuilder().group({
    min_amount: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    max_amount: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    is_bnpl_long_enabled: [''],
    is_sdd_payment_enabled: [''],
  });

  create_contract_from_group: FormGroup = new FormBuilder().group({
    sales_network_id: ['', [Validators.required, Validators.pattern(STRING_PATTERN), Validators.maxLength(10)]],
  });

  orders_filter_form_group: FormGroup = new FormBuilder().group({
    order_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    company_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    buyer_name: ['', [Validators.maxLength(50), Validators.pattern(BUYER_NAME_PATTERN)]],
    origin: [''],
    channel: [''],
    created_from: [''],
    created_to: [''],
    completed_from: [''],
    completed_to: [''],
    status: [''],
    bd1: [''],
    bd2: [''],
    bd5: [''],
    liquidation: [''],
    qinetic_id: [''],
    store_name: [''],
    approved: [''],
    external_id: [''],
    phone_number: [''],
    owner_link: [''],
    qinetic_bug: [''],
    tax_deduction: [''],
    tax_deduction_type: [''],
    merchant_refund: [''],
    has_qinetic_id: [''],
    last_operation: [''],
    last_operation_from: [''],
    last_operation_to: [''],
    agreement: [''],
  });

  steps_filter_from_group: FormGroup = new FormBuilder().group({
    order_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    qinetic_id: [''],
    steps_id: [''],
    created_from: [''],
    created_to: [''],
    due_date_from: [''],
    due_date_to: [''],
  });

  unpaid_filter_form_group: FormGroup = new FormBuilder().group({
    order_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    step_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    created_from: [''],
    created_to: [''],
    due_date_from: [''],
    due_date_to: [''],
    status: [''],
    qinetic_id: [''],
    unpaid_days: [''],
    unsolved: [''],
    buyer_name: [''],
    company_name: [''],
    store_name: [''],
  });

  unpaid_set_note_form_group: FormGroup = new FormBuilder().group({
    note: [''],
  });

  buyers_filter_from_group: FormGroup = new FormBuilder().group({
    buyer_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    buyer_name: ['', [Validators.maxLength(50), Validators.pattern(BUYER_NAME_PATTERN)]],
    phone_value: ['', [Validators.pattern(NUMBER_PATTERN), Validators.maxLength(15)]],
    email: ['', [Validators.email, Validators.maxLength(50)]],
    onboarding_completed_from: [''],
    onboarding_completed_to: [''],
  });

  sellers_filter_from_group: FormGroup = new FormBuilder().group({
    seller_id: ['', [Validators.maxLength(30), Validators.pattern(STRING_PATTERN)]],
    seller_name: [''],
    phone_value: ['', [Validators.pattern(NUMBER_PATTERN), Validators.maxLength(15)]],
    email: ['', [Validators.email, Validators.maxLength(50)]],
    is_confirmed: [''],
  });

  company_edit_form_group: FormGroup = new FormBuilder().group({
    business_name: ['', [Validators.required, Validators.maxLength(70), Validators.pattern(STRING_PATTERN)]],
    vat: ['', [Validators.required, Validators.pattern(PIVA_PATTERN)]],
    website: ['', Validators.pattern(WEBSITE_PATTERN)],
  });

  buyer_residency_form_group: FormGroup = new FormBuilder().group({
    city: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    address: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    country: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    province: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    zip_code: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    house_number: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
  });

  buyer_domicile_form_group: FormGroup = new FormBuilder().group({
    city: ['', [Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    address: ['', [Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    country: ['', [Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    province: ['', [Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    zip_code: ['', [Validators.pattern(DOMICILE_ZIP_CODE_PATTERN)]],
    house_number: ['', [Validators.pattern(STRING_PATTERN)]],
  });

  buyer_personal_info_form_group: FormGroup = new FormBuilder().group({
    buyer_firstname: ['', [Validators.required, Validators.maxLength(40)]],
    buyer_lastname: ['', [Validators.required, Validators.maxLength(40)]],
    tax_code: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    birthday: ['', [Validators.required]],
    birthplace: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    birthregion: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    birthregion_code: [
      '',
      [
        Validators.required,
        Validators.maxLength(PROVINCE_CODE_MAX_LENGTH),
        Validators.pattern(STRING_SPECIAL_CHAR_PATTERN),
      ],
    ],
    birthcountry: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    gender: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    citizenship: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    secondary_citizenship: ['', [Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    cdg: [''],
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
    communication_channel: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
  });

  buyer_personal_id_form_group: FormGroup = new FormBuilder().group({
    issuer: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    doc_type: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    doc_number: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    issuer_type: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    issue_country: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    issue_province: ['', [Validators.required, Validators.pattern(STRING_SPECIAL_CHAR_PATTERN)]],
    emission_date: ['', [Validators.required, Validators.required]],
    expiration_date: ['', [Validators.required, Validators.required]],
  });

  buyer_aml_form_group: FormGroup = new FormBuilder().group({
    activity: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    sector: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    occupation: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    is_apical_subject: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    business_place: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    tae: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    activity_code: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    sector_code: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
    occupation_code: ['', [Validators.required, Validators.pattern(STRING_PATTERN)]],
  });

  note_form_group: FormGroup = new FormBuilder().group({
    note: ['', [Validators.required, Validators.pattern(NOTE_PATTERN)]],
  });

  seller_set_phone_form_group: FormGroup = new FormBuilder().group({
    phone_prefix: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN)]],
    phone_value: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN), Validators.maxLength(15)]],
  });

  seller_edit_form_group: FormGroup = new FormBuilder().group({
    firstname: ['', [Validators.required, Validators.maxLength(70), Validators.pattern(STRING_PATTERN)]],
    lastname: ['', [Validators.required, Validators.maxLength(70), Validators.pattern(STRING_PATTERN)]],
  });

  set_sales_network_form_group: FormGroup = new FormBuilder().group({
    sales_network_id: ['', [Validators.required, Validators.pattern(NUMBER_PATTERN), Validators.maxLength(20)]],
  });

  set_product_category_form_group: FormGroup = new FormBuilder().group({
    product_category: [''],
  });

  set_origin_form_group: FormGroup = new FormBuilder().group({
    origin: [''],
  });

  set_agreement_form_group: FormGroup = new FormBuilder().group({
    agreement: [''],
  });

  set_sales_reference_email_form_group: FormGroup = new FormBuilder().group({
    sales_reference_email: ['', [Validators.email]],
  });

  report_form_group: FormGroup = new FormBuilder().group({
    report_type: ['', [Validators.required]],
    from: ['', [Validators.required]],
    to: ['', [Validators.required]],
    email: ['', [Validators.required]],
    status: [''],
    agreement: [''],
    product_category: [''],
    created_from: [''],
    created_to: [''],
    last_login_from: [''],
    last_login_to: [''],
    amount_min: ['', [Validators.pattern(NUMBER_PATTERN)]],
    amount_max: ['', [Validators.pattern(NUMBER_PATTERN)]],
    onboarding_completed_from: [''],
    onboarding_completed_to: [''],
    exclude_gdpr: [''],
  });

  reset_mfa_form_group: FormGroup = new FormBuilder().group({
    type: ['', [Validators.required]],
  });

  company_settings_form_group: FormGroup = new FormBuilder().group({
    is_store_payment_method_enabled: [''],
    is_iban_refund_enabled: [''],
    is_ext_order_id_enabled: [''],
    is_tax_deduction_enabled: [''],
    is_tax_date_and_number_enabled: [''],
    tax_deduction_type: [''],
    is_custom_domains_enabled: [''],
    is_prepaid_cards_blocked: [''],
    is_prepaid_cards_blocked_on_long: [''],
    is_prepaid_cards_blocked_on_ecommerce: [''],
    is_fourthline_onboarding_enabled: [''],
  });

  store_plugin_credentials_form_group: FormGroup = new FormBuilder().group({
    client_id: [''],
    client_secret: [''],
  });

  company_subdomain_form_group: FormGroup = new FormBuilder().group({
    subdomain: ['', [Validators.required, Validators.pattern(SIMPLE_STRING_PATTERN)]],
  });

  company_archive_form_group: FormGroup = new FormBuilder().group({
    note: ['', [Validators.required]],
  });

  company_archive_note_form_group: FormGroup = new FormBuilder().group({
    note: ['', [Validators.required]],
  });

  company_stand_by_notes_form_group: FormGroup = new FormBuilder().group({
    stand_by_notes: ['', [Validators.required]],
  });

  sellers_confirm_otp_form_group: FormGroup = new FormBuilder().group({
    confirm_reason: ['', [Validators.required]],
  });

  pending_invitations_filter_form_group: FormGroup = new FormBuilder().group({
    company_id: [''],
    company_business_name: [''],
    recipient_email: ['', [Validators.email]],
    sender_email: ['', [Validators.email]],
  });

  buyers_confirm_otp_form_group: FormGroup = new FormBuilder().group({
    confirm_reason: ['', [Validators.required]],
  });

  company_enable_from_group: FormGroup = new FormBuilder().group({
    is_enabled: [''],
    is_partially_enabled: [''],
  });

  scripts_form_group: FormGroup = new FormBuilder().group({
    script_type: ['', [Validators.required]],
  });

  vop_new_check_from_group: FormGroup = new FormBuilder().group({
    beneficiary_firstname: ['', [Validators.maxLength(70), Validators.pattern(BUYER_NAME_PATTERN)]],
    beneficiary_lastname: ['', [Validators.maxLength(70), Validators.pattern(BUYER_NAME_PATTERN)]],
    beneficiary_tax_code: ['', [Validators.pattern(STRING_PATTERN)]],
    iban: ['', [Validators.required]],
  });

  product_category_new_category_from_group: FormGroup = new FormBuilder().group({
    name: ['', [Validators.required]],
    decido_evaluation_code: ['', [Validators.required]],
    first_subcategory: ['', [Validators.required]],
    installment_plans: new FormBuilder().array([]),
  });

  product_category_update_category_from_group: FormGroup = new FormBuilder().group({
    name: ['', [Validators.required]],
    decido_evaluation_code: ['', [Validators.required]],
  });

  product_category_update_steps_from_group: FormGroup = new FormBuilder().group({
    installment_plans: new FormBuilder().array([]),
  });

  cluster_update_usury_threshold_form_group: FormGroup = new FormBuilder().group({
    max_tan: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
  });

  product_subcategory_new_subcategory_from_group: FormGroup = new FormBuilder().group({
    name: ['', [Validators.required]],
    ecommerce_default: [false, [Validators.required]],
  });

  product_subcategory_update_subcategory_from_group: FormGroup = new FormBuilder().group({
    name: ['', [Validators.required]],
    ecommerce_default: ['', [Validators.required]],
  });

  matcher: FormErrorStateMatcher = new FormErrorStateMatcher();

  validateForm(form_group: FormGroup): boolean {
    let valid: boolean = true;
    for (let control_name of Object.keys(form_group.controls)) {
      if (form_group.get(control_name)?.invalid) {
        valid = false;
      }
    }
    return valid;
  }
}

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const is_submitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || is_submitted));
  }
}
